import EventClass from './EventClass'

export default new EventClass
